import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType } from "../../../isp._comun/iu/_principal/constantesIuPrin";

export default class VentanaQueryAsociados extends Ventana {
    constructor() {
        super();
        this.id = DialogType.QUERY_ASOCIADOS;
        // this.id = VentanaQueryAsociados.constructor.name;
        // this.ventanaCargando = null;
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaQueryAsociados)) {
            return false;
        }
        return true;
    }

    clonar() {
        const nuevaVentana = new VentanaQueryAsociados();
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.id = this.id;
        // nuevaVentana.ventanaCargando = this.ventanaCargando;
        return nuevaVentana;
    }
}
